import { useState, useEffect } from 'react';
import { api } from '../api';

const CHQ_ESTADO = {
  V: { label: 'Vigente',    color: '#4cc9f0', bg: '#1a2a3e' },
  C: { label: 'Cobrado',    color: '#4caf50', bg: '#1a3a2a' },
  A: { label: 'Anulado',    color: '#555',    bg: '#1a1a2e' },
  S: { label: 'Sin fondos', color: '#e63946', bg: '#3a1a1a' },
  P: { label: 'Perdido',    color: '#f72585', bg: '#3a0a2a' },
};

const fmt = (n) => (n || 0).toLocaleString('es-EC', { minimumFractionDigits: 2 });

const FILTROS = [
  { key: 'todos',   label: 'Todos'          },
  { key: 'V',       label: '🔵 Vigentes'    },
  { key: 'C',       label: '✅ Cobrados'    },
  { key: 'alertas', label: '🚨 Alertas'     },
  { key: 'A',       label: '⚪ Anulados'    },
];

export default function TabCheques() {
  const [datos,      setDatos]      = useState(null);
  const [cargando,   setCargando]   = useState(true);
  const [filtro,     setFiltro]     = useState('todos');
  const [busq,       setBusq]       = useState('');
  const [drawer,     setDrawer]     = useState(null);   // cedula
  const [drawerData, setDrawerData] = useState(null);
  const [cargDrawer, setCargDrawer] = useState(false);

  useEffect(() => { cargar('todos'); }, []);

  const cargar = async (f) => {
    setCargando(true);
    setFiltro(f);
    try {
      const data = await api.get(`/cheques-clientes/resumen?filtro=${f}`);
      setDatos(data.error ? null : data);
    } catch(e) { console.error(e); }
    finally { setCargando(false); }
  };

  const abrirDrawer = async (cedula) => {
    setDrawer(cedula);
    setDrawerData(null);
    setCargDrawer(true);
    try {
      const data = await api.get(`/cheques-clientes/cliente/${cedula}`);
      setDrawerData(data.error ? null : data);
    } catch(e) { console.error(e); }
    finally { setCargDrawer(false); }
  };

  const chequesFiltrados = (datos?.cheques || []).filter(c =>
    !busq ||
    c.cliente.toUpperCase().includes(busq.toUpperCase()) ||
    c.cedula.includes(busq) ||
    c.num_cheque.includes(busq) ||
    c.fac_numero.includes(busq)
  );

  const kpis = datos?.kpis;

  return (
    <div>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>
        <div>
          <h3 style={{ color: '#fff', margin: 0 }}>🧾 Cheques de Clientes</h3>
          <p style={{ color: '#555', fontSize: 12, marginTop: 4 }}>Desde Dic 2025 · Banco Internacional</p>
        </div>
        <button
          style={{ background: 'none', border: '1px solid #444', borderRadius: 8, color: '#aaa', padding: '8px 16px', cursor: 'pointer', fontSize: 13 }}
          onClick={() => cargar(filtro)}>
          🔄 Actualizar
        </button>
      </div>

      {/* KPIs */}
      {kpis && (
        <div style={{ display: 'flex', gap: 10, marginBottom: 20, flexWrap: 'wrap' }}>
          {[
            { label: 'Vigentes',     valor: kpis.vigentes,     sub: `$${fmt(kpis.valor_vigente)}`, color: '#4cc9f0', cursor: true, f: 'V' },
            { label: 'Próx. 7 días', valor: kpis.proximos_7d,  sub: 'por vencer',                  color: '#ffc107', cursor: false },
            { label: 'Cobrados',     valor: kpis.cobrados,     sub: `$${fmt(kpis.valor_cobrado)}`, color: '#4caf50', cursor: true, f: 'C' },
            { label: '🚨 Alertas',   valor: kpis.alertas,      sub: `${kpis.sin_fondos} sf · ${kpis.perdidos} perd.`, color: '#e63946', cursor: true, f: 'alertas' },
            { label: 'Conciliados',  valor: kpis.conciliados,  sub: 'en banco ✓',                  color: '#4caf50', cursor: false },
          ].map((k, i) => (
            <div key={i}
              onClick={() => k.cursor && cargar(k.f)}
              style={{
                background: '#1e1e2e', borderRadius: 10, padding: '14px 18px',
                flex: 1, minWidth: 120, borderTop: `3px solid ${k.color}`,
                cursor: k.cursor ? 'pointer' : 'default',
              }}>
              <div style={{ color: k.color, fontSize: 22, fontWeight: 'bold', marginBottom: 4 }}>{k.valor}</div>
              <div style={{ color: '#aaa', fontSize: 11 }}>{k.label}</div>
              <div style={{ color: '#555', fontSize: 10, marginTop: 2 }}>{k.sub}</div>
            </div>
          ))}
        </div>
      )}

      {/* Filtros + búsqueda */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 14, flexWrap: 'wrap', alignItems: 'center' }}>
        {FILTROS.map(f => (
          <button key={f.key}
            style={{
              background: filtro === f.key ? '#1a2a3e' : '#1e1e2e',
              border: filtro === f.key ? '1px solid #4cc9f0' : '1px solid #2d2d44',
              borderRadius: 6, color: filtro === f.key ? '#4cc9f0' : '#888',
              padding: '6px 14px', cursor: 'pointer', fontSize: 12,
            }}
            onClick={() => cargar(f.key)}>
            {f.label}
          </button>
        ))}
        <input
          style={{ flex: 1, minWidth: 200, background: '#0f0f1a', border: '1px solid #2d2d44', borderRadius: 8, color: '#fff', padding: '7px 12px', fontSize: 13 }}
          placeholder="Buscar cliente, cédula, cheque o factura..."
          value={busq}
          onChange={e => setBusq(e.target.value)}
        />
      </div>

      {/* Tabla */}
      {cargando ? (
        <p style={{ color: '#aaa', textAlign: 'center', padding: 40 }}>Cargando cheques...</p>
      ) : !datos ? (
        <p style={{ color: '#e63946' }}>Error cargando datos</p>
      ) : (
        <>
          <div style={{ background: '#1e1e2e', borderRadius: 12, overflow: 'hidden' }}>
            <div style={{ display: 'flex', padding: '10px 16px', background: '#0f0f1a', color: '#555', fontSize: 11, fontWeight: 'bold', gap: 8 }}>
              <span style={{ width: 80  }}>N° CHEQUE</span>
              <span style={{ flex: 3   }}>CLIENTE</span>
              <span style={{ width: 100 }}>FECHA CHQ.</span>
              <span style={{ width: 100 }}>REGISTRO</span>
              <span style={{ width: 100, textAlign: 'right' }}>VALOR</span>
              <span style={{ width: 120 }}>FACTURA</span>
              <span style={{ width: 110, textAlign: 'center' }}>ESTADO</span>
              <span style={{ width: 110, textAlign: 'center' }}>BANCO</span>
            </div>

            <div style={{ maxHeight: 'calc(100vh - 420px)', overflowY: 'auto' }}>
              {chequesFiltrados.length === 0 ? (
                <p style={{ color: '#555', textAlign: 'center', padding: 32 }}>Sin cheques para este filtro</p>
              ) : chequesFiltrados.map((c, i) => {
                const est = CHQ_ESTADO[c.estado] || CHQ_ESTADO.V;
                return (
                  <div key={i}
                    onClick={() => abrirDrawer(c.cedula)}
                    style={{
                      display: 'flex', padding: '10px 16px', gap: 8,
                      alignItems: 'center', cursor: 'pointer',
                      background: i % 2 === 0 ? '#1e1e2e' : '#1a1a2e',
                      borderLeft: `3px solid ${est.color}`,
                      transition: 'background 0.15s',
                    }}
                    onMouseEnter={e => e.currentTarget.style.background = '#2d2d44'}
                    onMouseLeave={e => e.currentTarget.style.background = i % 2 === 0 ? '#1e1e2e' : '#1a1a2e'}>

                    {/* N° cheque */}
                    <span style={{ width: 80, color: '#4cc9f0', fontSize: 12, fontFamily: 'monospace' }}>
                      #{c.num_cheque}
                    </span>

                    {/* Cliente */}
                    <span style={{ flex: 3 }}>
                      <div style={{ color: '#fff', fontSize: 12, fontWeight: '600' }}>{c.cliente}</div>
                      <div style={{ color: '#555', fontSize: 10 }}>{c.cedula}</div>
                    </span>

                    {/* Fecha cheque */}
                    <span style={{ width: 100, fontSize: 12 }}>
                      <div style={{ color: c.postfechado ? '#ffc107' : '#aaa' }}>{c.fecha_cheque}</div>
                      {c.postfechado && <div style={{ color: '#ffc107', fontSize: 10 }}>+{c.dias_venc}d</div>}
                    </span>

                    {/* Registro */}
                    <span style={{ width: 100, color: '#555', fontSize: 11 }}>{c.fecha_registro}</span>

                    {/* Valor */}
                    <span style={{ width: 100, textAlign: 'right', color: '#fff', fontWeight: 'bold', fontSize: 13 }}>
                      ${fmt(c.valor)}
                    </span>

                    {/* Factura */}
                    <span style={{ width: 120, color: '#555', fontSize: 11, fontFamily: 'monospace' }}>
                      {c.fac_numero || c.fac_documento || '—'}
                    </span>

                    {/* Estado */}
                    <span style={{ width: 110, textAlign: 'center' }}>
                      <span style={{
                        background: est.bg, color: est.color,
                        borderRadius: 6, padding: '2px 8px',
                        fontSize: 10, fontWeight: 'bold',
                      }}>
                        {est.label}
                      </span>
                    </span>

                    {/* Cruce bancario */}
                    <span style={{ width: 110, textAlign: 'center' }}>
                      {c.conciliado ? (
                        <span style={{ background: '#1a3a2a', color: '#4caf50', borderRadius: 6, padding: '2px 8px', fontSize: 10, fontWeight: 'bold' }}>
                          ✓ ${fmt(c.banco_credito)}
                        </span>
                      ) : c.estado === 'V' ? (
                        <span style={{ color: '#333', fontSize: 10 }}>Sin confirmar</span>
                      ) : null}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '10px 16px', color: '#555', fontSize: 12 }}>
            {chequesFiltrados.length} cheques · Total: <strong style={{ color: '#4cc9f0', marginLeft: 6 }}>
              ${fmt(chequesFiltrados.reduce((a, c) => a + c.valor, 0))}
            </strong>
          </div>
        </>
      )}

      {/* ══ DRAWER CLIENTE ══ */}
      {drawer && (
        <>
          <div onClick={() => setDrawer(null)}
            style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 100 }} />
          <div style={{
            position: 'fixed', top: 0, right: 0, bottom: 0, width: 460,
            background: '#1e1e2e', zIndex: 101, display: 'flex', flexDirection: 'column',
            boxShadow: '-4px 0 24px rgba(0,0,0,0.5)',
          }}>
            {/* Header */}
            <div style={{ padding: '20px 24px', borderBottom: '1px solid #2d2d44', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <div style={{ color: '#4cc9f0', fontWeight: 'bold', fontSize: 15 }}>🧾 Cheques del cliente</div>
                {drawerData && (
                  <>
                    <div style={{ color: '#fff', fontSize: 14, marginTop: 4 }}>
                      {drawerData.cheques[0]?.cliente || drawer}
                    </div>
                    <div style={{ color: '#555', fontSize: 11 }}>{drawer}</div>
                  </>
                )}
              </div>
              <button onClick={() => setDrawer(null)}
                style={{ background: 'none', border: 'none', color: '#555', fontSize: 20, cursor: 'pointer' }}>✕</button>
            </div>

            {/* Resumen */}
            {drawerData && (
              <div style={{ display: 'flex', gap: 8, padding: '12px 24px', borderBottom: '1px solid #2d2d44' }}>
                {[
                  ['Total',    `$${fmt(drawerData.total_valor)}`,   '#fff'    ],
                  ['Vigente',  `$${fmt(drawerData.total_vigente)}`,  '#4cc9f0'],
                  ['Cobrado',  `$${fmt(drawerData.total_cobrado)}`,  '#4caf50'],
                  ['Cheques',  drawerData.total,                     '#aaa'   ],
                ].map(([label, val, color]) => (
                  <div key={label} style={{ flex: 1, background: '#0f0f1a', borderRadius: 8, padding: '8px 10px', textAlign: 'center' }}>
                    <div style={{ color, fontSize: 14, fontWeight: 'bold' }}>{val}</div>
                    <div style={{ color: '#555', fontSize: 10 }}>{label}</div>
                  </div>
                ))}
              </div>
            )}

            {/* Lista cheques */}
            <div style={{ flex: 1, overflowY: 'auto', padding: '16px 24px' }}>
              {cargDrawer ? (
                <p style={{ color: '#aaa', textAlign: 'center', padding: 40 }}>Cargando...</p>
              ) : !drawerData ? (
                <p style={{ color: '#e63946' }}>Error cargando cheques</p>
              ) : drawerData.cheques.map((c, i) => {
                const est = CHQ_ESTADO[c.estado] || CHQ_ESTADO.V;
                return (
                  <div key={i} style={{
                    background: '#0f0f1a', borderRadius: 10, padding: '14px 16px',
                    marginBottom: 10, borderLeft: `3px solid ${est.color}`,
                  }}>
                    {/* Fila 1: número + estado + valor */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                      <span style={{ color: '#4cc9f0', fontFamily: 'monospace', fontSize: 13, fontWeight: 'bold' }}>
                        #{c.num_cheque}
                      </span>
                      <span style={{ background: est.bg, color: est.color, borderRadius: 6, padding: '2px 8px', fontSize: 10, fontWeight: 'bold' }}>
                        {est.label}
                      </span>
                      <span style={{ color: '#fff', fontSize: 15, fontWeight: 'bold' }}>
                        ${fmt(c.valor)}
                      </span>
                    </div>

                    {/* Grid de datos */}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px 12px', fontSize: 12 }}>
                      {[
                        ['Fecha cheque',  c.fecha_cheque  + (c.postfechado ? ` (+${c.dias_venc}d)` : '')],
                        ['Registrado',    c.fecha_registro],
                        ['Banco',         c.banco          || '—'],
                        ['Factura',       c.fac_numero || c.fac_documento || '—'],
                      ].map(([label, val]) => (
                        <div key={label}>
                          <div style={{ color: '#555', fontSize: 10 }}>{label}</div>
                          <div style={{ color: '#aaa', fontSize: 12, marginTop: 1 }}>{val}</div>
                        </div>
                      ))}
                    </div>

                    {/* Cruce bancario */}
                    {c.conciliado && (
                      <div style={{ marginTop: 10, background: '#1a3a2a', borderRadius: 6, padding: '8px 12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span style={{ color: '#4caf50', fontSize: 11, fontWeight: 'bold' }}>✓ Confirmado en Banco Internacional</span>
                        <div style={{ textAlign: 'right' }}>
                          <div style={{ color: '#4caf50', fontSize: 13, fontWeight: 'bold' }}>${fmt(c.banco_credito)}</div>
                          <div style={{ color: '#555', fontSize: 10 }}>{c.banco_fecha}</div>
                        </div>
                      </div>
                    )}
                    {!c.conciliado && c.estado === 'V' && (
                      <div style={{ marginTop: 10, background: '#1a2a3e', borderRadius: 6, padding: '6px 12px' }}>
                        <span style={{ color: '#555', fontSize: 11 }}>⏳ Pendiente confirmar en estado de cuenta</span>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
